import { DEFAULT_LANGUAGE } from '@/i18n';
import domus, { type PluginOptions } from '@smg-real-estate/domus';
import { createHead } from '@unhead/vue/client';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import VueScrollTo from 'vue-scrollto';
import VueApexCharts from 'vue3-apexcharts';

import AppSmg from './AppSmg.vue';
import auth0 from './auth/auth0Plugin';
import { setupDevProxy } from './dev/setupDevProxy';
import { i18n } from './i18n-setup-hg';
import { router } from './router';
import { initBrowserRum } from './services/datadog/DatadogService';
import store from './store';

const app = createApp(AppSmg, {
  // TODO: check if this works?
  onMounted: () => {
    // This will throw an error on IE11, but we don't need to know about it, so just catch the error.
    try {
      document.dispatchEvent(new Event('x-app-rendered'));
    } catch (error) {
      /* empty */
    }
  },
});

const head = createHead();

const domusOptions: PluginOptions = {
  theme: 'smg',
  i18n: { instance: i18n, languages: { name: 'all', mode: 'lazy' } },
  router: { instance: router, defaultLanguage: DEFAULT_LANGUAGE },
};
// Disable datadog browser rum for local development
if (import.meta.env.VUE_APP_STAGE !== 'personal') {
  initBrowserRum();
}

// Rewrite absolute experiment API URLs to go through the Vite dev-server proxy.
// import.meta.env.DEV is a Vite built-in that is always `false` in vite build
// output, so this entire branch (and the imported module) is tree-shaken out
// of every production bundle. The import is static (not dynamic) so the
// interceptor is registered synchronously before app.mount() runs.
if (import.meta.env.DEV) {
  setupDevProxy();
}

app.use(head);
app.use(router);
app.use(auth0 as any);
const pinia = createPinia();
app.use(pinia);
app.use(store);
app.use(i18n);
app.use(VueApexCharts);
app.use(VueScrollTo);
app.use(domus, domusOptions);
app.mount('#app');
